<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-container class="mt-3">
            <form>
                <span>Company Name: {{ companyName }}</span>
                <v-data-table :headers="headers" :items="dataForTable" class="elevation-1">
                    <template v-slot: slot:item.email v-html="email" />
                    <template v-slot: slot:item.role v-html="item.role" />

                    <template v-slot:item.action="{ item }">
                        <v-btn v-if="!isLoggedInUser(item)" icon @click.native="openRoleDialog(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.action2="{ item }">
                        <v-btn v-if="!isLoggedInUser(item)" icon @click.native="openConfirmDialog(item)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </form>
        </v-container>

        <v-dialog v-model="confirmRemove" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Remove user profile from company?</v-card-title>
                </v-flex>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="confirmRemove = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="update('isActive')" data-cy="btnConfirmArchive"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="roleDialog" max-width="550px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Assigned Roles</v-card-title>
                </v-flex>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-radio-group v-model="selectedRoles" :mandatory="true">
                                <v-radio label="Admin" value="Admin"></v-radio>
                                <v-radio label="Read Only" value="Read Only"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="roleDialog = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="save()" data-cy="btnConfirmArchive"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios'
import { authHeader } from '../_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,

            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',
            role: null,
            confirmRemove: false,
            profileForRemoving: null,
            roleDialog: false,
            profileForRoleUpdate: null,
            selectedRoles: '',
            dataForTable: [],
            companyName: '',
            headers: [
                {
                    text: 'Email',
                    value: 'email',
                    align: 'left'
                },
                {
                    text: 'Roles',
                    value: 'role',
                    align: 'left'
                },
                { text: 'Role', value: 'action', sortable: false },
                { text: 'Remove', value: 'action2', sortable: false }
            ],
            roles: 'Admin'
        }
    },
    methods: {
        openRoleDialog(item) {
            this.profileForRoleUpdate = item
            this.selectedRoles = this.profileForRoleUpdate.role
            this.roleDialog = true
        },
        openConfirmDialog(item) {
            this.profileForRemoving = item
            this.confirmRemove = true
        },
        getProfiles() {
            this.dataForTable = []
            let params = {
                companyId: this.$store.state.authentication.loggedInUser.companyId
            }
            axios
                .get(this.$store.state.userUrl, {
                    params: params,
                    headers: authHeader()
                })
                .then(response => {
                    this.companyName = response.data[0].company.companyName
                    for (let i = 0; i < response.data.length; i++) {
                        let _data = {
                            userId: response.data[i].userId,
                            companyId: response.data[i].companyId,
                            email: response.data[i].email,
                            role: response.data[i].role,
                            isActive: response.data[i].isActive
                        }
                        this.dataForTable.push(_data)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        update(field) {
            this.loading = true
            const app = this
            let snackbarParams
            let params = {}

            if (field === 'role') {
                params = {
                    userId: app.profileForRoleUpdate.userId,
                    companyId: app.profileForRoleUpdate.companyId,
                    role: app.selectedRoles
                }
            }

            if (field === 'isActive') {
                params = {
                    userId: app.profileForRemoving.userId,
                    companyId: app.profileForRemoving.companyId,
                    isActive: false
                }
            }

            axios
                .patch(
                    `${this.$store.state.userUrl}/adminUpdate`,
                    {
                        params: params
                    },
                    { headers: authHeader() }
                )
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.profileForRemoving = null
                    app.confirmRemove = false
                    app.profileForRoleUpdate = null
                    app.roleDialog = false
                    app.getProfiles()
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        save() {
            let app = this
            this.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        if (app.selectedRoles.length === 0) {
                            let snackbarParams = {
                                message: 'Must have at least one role selected',
                                context: 'error'
                            }
                            app.$store.commit('showSnackbar', snackbarParams)
                            return false
                        }
                        app.update('role')
                    }
                })
                .catch(() => {
                    return false
                })
        },
        isLoggedInUser(userInfo) {
            return userInfo.email === this.$store.state.authentication.loggedInUser.email
        }
    },
    created() {
        this.getProfiles()
    }
}
</script>
